import React from "react";
import DataPolicyPopup from "./data-policy-popup";

const FooterNew = () => (
  <footer className="footer">
        <p>Contact us at: <a href="tel:888-530-7592" className='phone-link'>888-530-7592</a></p>
        <p>&copy; 2025 Pinpoint Field Services. All Rights Reserved. <br/>
        PO Box 541026 <br/>
        Omaha, NE 68154 <br/>
        <a href="https://www.linkedin.com/company/pinpoint-field-services" target="_blank" rel="noopener noreferrer">
        <img src="..\img\In-Blue-14@2x.png" alt="LinkedIn Logo" /></a><br/>
        Icons by <a href="https://icons8.com" target="_blank" rel="noopener noreferer">Icons8</a>
        <DataPolicyPopup/>
      </p>
  </footer>
);

export default FooterNew;
